import { environment } from '../../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoutingService, TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-sloan-global-help',
    templateUrl: './sloan-global-help.component.html',
    styleUrls: ['./sloan-global-help.component.scss'],
    imports: [TranslatePipe]
})
export class SloanGlobalHelpComponent implements OnInit {

  phoneNumber  = environment.globalHelpphoneNumber;
  email = environment.globalHelpemail;
  workingDays = environment.globalHelpworkingDays;
  workingHours = environment.globalHelpworkingHours;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private routingService: RoutingService
  ) { }

  ngOnInit(): void {
  }

  closeModal(){
    this.ngbActiveModal.dismiss();
  }

  openFaqs(){
    this.closeModal();
    const faqUrl = new URL('/faq', window.location.origin);
    window.open(faqUrl.toString());
  }

}
